import React from "react";
import { Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useCart } from "../../context/CartContext";
import { FaCartPlus, FaImage } from "react-icons/fa";
import colors from "../../constants/colors";
import { formatPrice } from "../../utils/formatPrice";
import { useNavigate } from "react-router-dom";
const ProductCard = ({ product }) => {
  const { addToCart } = useCart();
  const navigate = useNavigate();

  const getLowestPrice = () => {
    if (product.hasVariants && product.variants && product.variants.length > 0) {
      const prices = product.variants.map(v => parseFloat(v.price));
      return Math.min(...prices);
    }
    return product.price;
  };

  const hasStock = () => {
    if (product.hasVariants && product.variants && product.variants.length > 0) {
      return product.variants.some(v => v.stock > 0);
    }
    return product.stock > 0;
  };

  const handleAddToCart = () => {
    if (product.hasVariants) {
      // Se tiver variantes, redireciona para a página de detalhes
      navigate(`/produtos/${product.id}`);
    } else {
      addToCart(product, 1);
    }
  };

  return (
    <Card className="h-100 product-card">
      {product.images && product.images[0] ? (
        <Card.Img
          variant="top"
          src={product.images[0].src}
          alt={product.name}
          loading="lazy"
          style={{ height: "200px", objectFit: "cover" }}
        />
      ) : (
        <div
          className="bg-light d-flex align-items-center justify-content-center"
          style={{ height: "200px" }}
        >
          <FaImage style={{ fontSize: "3rem" }} className="text-muted" />
        </div>
      )}
      <Card.Body className="d-flex flex-column">
        <Card.Title>{product.name}</Card.Title>
        <Card.Text className="text-muted small mb-2">
          {product.description?.length > 80
            ? product.description.substring(0, 80) + "..."
            : product.description}
        </Card.Text>
        <div className="mt-auto">
          <Card.Text className="fw-bold fs-5 mb-2">
            {product.hasVariants ? (
              <>
                A partir de {formatPrice(getLowestPrice())}€
              </>
            ) : (
              formatPrice(product.price) + "€"
            )}
          </Card.Text>
          <div className="d-flex gap-2">
            <Button
              as={Link}
              to={`/produtos/${product.id}`}
              className="flex-grow-1"
              style={{
                backgroundColor: colors.secondary,
                color: colors.light,
                borderColor: colors.secondary,
              }}
            >
              Ver Detalhes
            </Button>
            {!product.isDigital && (
              <Button
                onClick={handleAddToCart}
                disabled={!hasStock()}
                style={{
                  cursor: !hasStock() ? "not-allowed" : "pointer",
                  backgroundColor: colors.light,
                  color: colors.secondary,
                  borderColor: colors.secondary,
                }}
              >
                <FaCartPlus />
              </Button>
            )}
          </div>
          {!hasStock() && (
            <p className="text-danger small mt-2 mb-0">Fora de stock</p>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default ProductCard;
